import TimeTicketWeekApiAgency from '@/api/TimeTicketWeekApiAgency';
import TimeTicketWeekApiClient from '@/api/TimeTicketWeekApiClient';
import router from '@/router/index.router';
import { Reactive } from '@/utils/decorators';
import { defineAsyncComponent, reactive } from 'vue';
import BasePagedListFilterService from '../BasePagedListFilterService';
import useSelfService from '../SelfService';

export class TimeTicketYearPagedListFilterService
	extends BasePagedListFilterService<Armado.TimeTicketWeekPagedListParameters, Armado.TimeTicketWeekYear> {

	get quickFilters () { return undefined }
	protected get api () {
		return useSelfService().self.isAgency()
			? { grid: (listFilter: ITimeTicketWeekPagedListParameters) => TimeTicketWeekApiAgency.listByYearPagedListAsync(this.year, listFilter) }
			: { grid: (listFilter: ITimeTicketWeekPagedListParameters) => TimeTicketWeekApiClient.listByYearPagedListAsync(this.year, listFilter) };
	}

	get year () { return +router.currentRoute.value.params.year }

	@Reactive private readonly serviceState = { year: undefined as Undef<number> };

	readonly filterComponent = defineAsyncComponent(() => import('@/components/time-ticket/TimeTicketYearPagedListFilter.vue'));

	filter = reactive<Armado.TimeTicketWeekPagedListParameters>({
		...this.commonFilter,
		from: undefined as Undef<string>,
		to: undefined as Undef<string>,
		currentStep: undefined,
		showFlex: false,
		tagIds: [],
		hasTag: false,
		clientCompanyId: undefined as Undef<number>,
		agencyCompanyId: undefined as Undef<number>,
		missionPlaceId: undefined as Undef<number>,
	});

}

const timeTicketYearPagedListFilterServiceSingleton = new TimeTicketYearPagedListFilterService();

export default function usetimeTicketYearPagedListFilterService () {
	return timeTicketYearPagedListFilterServiceSingleton;
}
